$(function() {
  visibleBundleRemoveBtn();
});

function visibleBundleRemoveBtn() {
  var bundleReferenceList = [];
  $('.bundle-remove').each(function() {
    referenceVal = $(this).attr("data-bundlereference-id");
     bundleReferenceList.push(referenceVal);
  });
  bundleUniqueReference = $.unique(bundleReferenceList);
  $(bundleUniqueReference).each(function(id, eachReferVal) {
    $('.bundle-remove-'+eachReferVal).hide();
    $('.bundle-remove-'+eachReferVal).eq(0).show();
  });
}

function validateBoldProductVariants() {
  
  
  if (isApiBlocked === "Yes") {
    toastr.options = {
      "closeButton": true,
      "progressBar": true,
      "timeOut": "5000",
    }
    toastr['error']("You are not allowed to purchase this product", "");
    return false;
  }
  
  
  if ($("#customize_prod_option").val() == "") {
    toastr.options = {
      "closeButton": true,
      "progressBar": true,
      "timeOut": "5000",
    }
    toastr['error']("Please select the customization option", "");
    return false;
  }

  allowSubmit = 1;
  tempPlayerRowId = getCookie("currentlySelected");
  showSelectedPlayerNames = $(".show_player_names_"+tempPlayerRowId).html();

  if(typeof showSelectedPlayerNames === 'undefined') {
    tempPlayerRowId = "";
  }

  if (clubIsByPassLogin != 1 && isCustomerLoggedIn == false) {
    allowSubmit = 0;
    errorMsg = "Please login before add your product into cart!";
  }
  else if ((tempPlayerRowId == "" || tempPlayerRowId == undefined || tempPlayerRowId == 0) && clubIsSkipPlayer != 1 ) {
    allowSubmit = 0;
	errorMsg = "You must complete all options before adding the product to the cart";
  } else {
    $("#sz_club_id").val(currentClubId);
    if (currentClubId == "") {
      $(".productdetail_playerinfo").remove();
    } else {
      $('.clubProperties').each(function() {
        if ($(this).val() == "") {
          $(this).remove();
        }
      });
    }    

    $('.bold-bundles-child-product__variant-selector').each(function() {
      currentlySelectedText = $(this).find("option:selected").text();
      currentlySelectedVal = $(this).find("option:selected").val();

      if (currentlySelectedText == "" || currentlySelectedVal == "") {
        allowSubmit = 0;
        return false;
      }
    });
    if (allowSubmit == 0) {
      errorMsg = "You must complete all of the options before adding the package.";
    }    
  }  

  if (allowSubmit == 0) {
    toastr.options = {
      "closeButton": true,
      "progressBar": true,
      "timeOut": "5000",
    }
    toastr['error'](errorMsg);
  } else if (allowSubmit == 1) {
    $(".bundle-grouping-id").remove();
    var randomStringVal = Math.round((new Date()).getTime() / 1000) + "-"+randomString(10);
    $("input#prodDtlId").after('<input type="hidden" name="properties[BundleReference]" class="removeInput required clubProperties bundle-grouping-id" value="'+randomStringVal+'" />'); 

    var boldVariantQty = {};
    $('.customProdQty').each(function() {
      boldVariant = $(this).attr("data-prodId");
      boldQty = $(this).attr("data-prod-qty");
      boldVariantQty[boldVariant] = boldQty;
    });
    document.cookie = "boldVariantQty-"+randomStringVal+"=" + JSON.stringify(boldVariantQty) + ";path=/";
    $("<span style='color:green;'>Please Wait! Your options are being created...</span>").insertBefore(".bold_clone");
    $(".bold_clone").css("display","none");
    currentUrl = window.location.href;
	document.cookie = "cartLastProductUrl=" + currentUrl + ";path=/";
  }
  return allowSubmit;
}

function boldClubProperties(formValues) {
      $("#sz_cuztomization").remove();
      if ($("#customize_prod_option").val() == "Yes") {
        $("<input>").attr({
            name: "properties[Customization]",
            class: "removeInput required clubProperties",
            id: "sz_cuztomization", 
            type: "hidden", 
            value: "Yes",
            required: ""
        }).insertAfter("#prodDtlId");
      } else if ($("#customize_prod_option").val() == "No") {
        $("<input>").attr({ 
            name: "properties[Customization]",
            class: "removeInput required clubProperties",
            id: "sz_cuztomization", 
            type: "hidden", 
            value: "No",
            required: ""
        }).insertAfter("#prodDtlId");
      } else {
        $("#sz_cuztomization").remove();
      }

  var cartProperties = formValues.properties;
  var clubPropertiesVal = {};
  $('.clubProperties').each(function() {
    var currentElement = $(this).val();
    if (currentElement != "") {
      keyName = $(this).attr("name").split('[').pop().split(']')[0];
      clubPropertiesVal[keyName] = currentElement;
    }
  });
  if (document.querySelector('.bold_options_loaded') !== null) {
    var boldOptionArray = $('.bold_options_loaded').find('select, textarea, input').serializeArray();
    $(boldOptionArray).each(function(i, field){
      keyName = field.name.split('[').pop().split(']')[0];
      clubPropertiesVal[keyName] = field.value;
    });
  }
  var propertiesVal = $.extend({}, cartProperties, clubPropertiesVal);
  delete formValues.properties;//delete old property values
  formValues.properties = propertiesVal;//append new property values
  return formValues;
}

function bundleRemove(bundleReferenceId) {
  
  var remove_items = {};
  $('.bundle-remove-'+bundleReferenceId).each(function() {
    remove_invalid_item = $(this).attr("data-cartitemkey");
    remove_items[remove_invalid_item] = 0;
  });

  $.ajax({
    url: '/cart/update.js',
    dataType: 'json',
    async: false,
    type: 'post',
    data: { updates: remove_items },
    success: function (itemData) {
      totalPriceVal = itemData.total_price;
      totalPriceVal = (totalPriceVal/100);
      productFinalPrice = '$' + parseFloat(totalPriceVal, 10).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,").toString();
      $(".money").html(productFinalPrice);
      
      $(".cart-bundle-row-"+bundleReferenceId).remove();
      cartItemDisplay();
    },
    error: function (XMLHttpRequest) {
      var response = eval('(' + XMLHttpRequest.responseText + ')');
      response = response.description;
      alert(response);
    }
  });  
}

function randomString(length) {
   var result           = '';
   var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
   var charactersLength = characters.length;
   for ( var i = 0; i < length; i++ ) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
   }
   return result;
}

function updateBoldProductPrice(product_quantity,prod_id_val,current_id) {
  if (product_quantity != undefined && product_quantity > 1) {
    //if quantity is more than 1 then 1 dropdown will show and others hide and one dropdown changes should apply to all dropdown
    currentSelectedVal = $("#"+current_id).find("option:selected").val();
    $('.bold-product-variant-'+prod_id_val).val(currentSelectedVal);
  }
    var boldVariantList = [];
    isAllSelected = 1;
    $('.bold-product-variant').each(function() {
      boldVariant = $(this).attr("data-bold-variant");    
      currentlySelectedText = $(this).find("option:selected").text();
      currentlySelectedVal = $(this).find("option:selected").val();
      if (currentlySelectedText == "" || currentlySelectedVal == "") {
        isAllSelected = 0;
      }
      boldVariantList.push(boldVariant);
    });

	var productFinalPrice;
    //if (isAllSelected == 1) {
      //Calculate price based on variant
      var totalPriceVal = 0;
      $(boldVariantList).each(function(id, val) {
        variantRowId = $(".bold-product-variant-"+val).find("option:selected").attr("value");
		eachRowPrice = parseFloat($(".bold-product-variant-"+val).find("option:selected").attr("data-regularpriceval"));
        if ( isNaN(eachRowPrice) === true) {
          eachRowPrice = $(".bold-product-variant-"+val).attr("data-base-price");
        }
        if (variantPrices !== undefined) {
          if (variantPrices[val] !== undefined) {
            if (variantPrices[val][variantRowId] !== undefined) {
              eachRowPrice = variantPrices[val][variantRowId];
            }
          }        
        }
        totalPriceVal = parseFloat(totalPriceVal) + parseFloat(eachRowPrice);
      });

      $('.prod-price-alt').each(function() {
        if ($(this).attr("data-prod-price-alt") != undefined && $(this).attr("data-prod-price-alt") != "") {
          totalPriceVal = parseFloat(totalPriceVal) + parseFloat($(this).attr("data-prod-price-alt"));
        }
      });
      
      productFinalPrice = totalPriceVal;
    /*} else {
      //Show default package price
      productFinalPrice = productDefaultPrice;
    }*/
  	productFinalPrice = '$' + parseFloat(productFinalPrice, 10).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,").toString();
  	$(".product-single__price-product-sz-template").html("<span id='ProductPrice-product-sz-template'><span class='money custom-price-val pre-money'>"+productFinalPrice+"</span></span>");
}

function hideVariantDropdown() {
  //Hide dropdown if variant has more than 1.
  $('.bold-product-variant').each(function() {
    boldVariant = $(this).attr("data-bold-variant");
    if ($(".bold-product-variant-"+boldVariant).length > 1) {
      $('.bold-product-variant-'+boldVariant).hide();
      $('.bold-product-variant-'+boldVariant).eq(0).show();
    }
  });
}

function apiGetBundleProductPrices() {
  var boldProductsList = [];
  $('.bold-product-variant').each(function() {
    boldVariant = $(this).attr("data-bold-variant");
    boldProductsList.push(boldVariant);
  });


  $.ajax({
    type: 'GET',
    url: appBaseUrl + "api/productVariants?boldProductsList="+boldProductsList,
    dataType: "jsonp",
  });

}

function apiBundlePriceCallback(response) {
  variantPrices = response.variant_prices;
  isApiVariantPulled = 'yes';
}